import React from 'react';
import { Box } from '@mui/material';

// The combined overview renders as an inset, bordered, rounded card (shared by the
// numeric, yes/no and free-form sections) so every section's overview looks the same.
const OverviewShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Box
        sx={{
            m: '0 20px 14px',
            p: '20px',
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: '10px',
        }}
    >
        {children}
    </Box>
);

export default OverviewShell;
